import React, { useState, useEffect, memo } from 'react'

import { ACTIVE, INACTIVE, ASC, DESC, NO_SORT } from '../constants'

const HeaderCellField = ({ column, displayName, enableSorting, setSort }) => {
  const [noSort, setNoSort] = useState(INACTIVE)
  const [ascSort, setAscSort] = useState(INACTIVE)
  const [descSort, setDescSort] = useState(INACTIVE)

  const onSortChanged = () => {
    setAscSort(column.isSortAscending() ? ACTIVE : INACTIVE)
    setDescSort(column.isSortDescending() ? ACTIVE : INACTIVE)
    setNoSort(
      !column.isSortAscending() && !column.isSortDescending()
        ? ACTIVE
        : INACTIVE
    )
  }

  useEffect(() => {
    column.addEventListener('sortChanged', onSortChanged)
    onSortChanged()
  }, [])

  const onSortRequested = (event) => {
    if (noSort === ACTIVE) {
      return setSort(DESC, event.shiftKey)
    }

    if (descSort === ACTIVE) {
      return setSort(ASC, event.shiftKey)
    }

    setSort(NO_SORT, event.shiftKey)
  }

  return (
    <div
      style={{ display: 'flex', flex: 1 }}
      className='customHeaderLabel'
      onClick={onSortRequested}
      onTouchEnd={onSortRequested}
    >
      {displayName}
      {enableSorting && (
        <div style={{ display: 'inline-block' }}>
          {descSort === ACTIVE && (
            <div className={`customSortDownLabel ${ascSort}`}>
              <span className='ag-icon ag-icon-desc' />
            </div>
          )}
          {ascSort === ACTIVE && (
            <div className={`customSortUpLabel ${descSort}`}>
              <span className='ag-icon ag-icon-asc' />
            </div>
          )}
        </div>
      )}
    </div>
  )
}

export default memo(HeaderCellField)
